import React from 'react'
import PropTypes from 'prop-types'
import '@loyal_template/order.css'
import Empty from './Empty'
import { ProductOrderItem } from './ProductOrderItem'

const ProductOrderList = props => {
  let productOrderList = []

  if (props.productOrders && props.productOrders.length > 0) {
    props.productOrders.map((product, index) =>
      productOrderList.push(
        <ProductOrderItem
          product={product}
          key={index}
          ready={props.ready}
          previousRoute={props.previousRoute}
          packageSize={props.packageSize}
        />
      )
    )
  } else if (!props.loading) {
    productOrderList.push(<Empty key={1} />)
  }

  return <div className='orders-item row'>{productOrderList}</div>
}

ProductOrderList.propTypes = {
  productOrders: PropTypes.array,
  ready: PropTypes.bool,
  loading: PropTypes.bool,
  previousRoute: PropTypes.string,
  packageSize: PropTypes.string
}
export default ProductOrderList



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderList.js